<div
  class="account-item"
  [class.account-item-padding-bottom]="!lastInList"
  [class.accounts-border-bottom]="!lastInList">
  <div class="d-flex flex-column gap-1">
    <span class="account-id">{{ account.displayableId }}</span>
    <span class="account-name" *ngIf="account?.employer">{{ account.employer }}</span>
  </div>
  <span class="account-balance">{{ account.totalBalance | currency }}</span>
</div>
